import React, { useState } from 'react';
import appStyle from "./AIAgentBot.module.css";
import RazorpayCheckout from '../RazorpayCheckout';

export default function SiteUsers({ limit, remaining, totalTopups, isLoading }) {
  const [showTopUpModal, setShowTopUpModal] = useState(false);
  const [topUpAmount, setTopUpAmount] = useState(1500);
  const [topUpQuantity, setTopUpQuantity] = useState(125);

  const totalCapacity = limit + totalTopups;
  const remainingPercentage = totalCapacity > 0 ? (remaining / totalCapacity) * 100 : 0;
  
  const isLow = () => {
    if (totalCapacity === 0) return false;
    return remainingPercentage < 20;
  };
  
  const hasTopups = totalTopups > 0;

  const handleTopUp = () => {
    setShowTopUpModal(true);
  };

  return (
    <>
      <div className={appStyle.creditSection}>
        <h3>👥 Site Users</h3>
        {isLoading ? (
          <div className={appStyle.loadingState}>
            <span className={appStyle.loadingSpinner}></span>
            <p>Loading user slots...</p>
          </div>
        ) : (
          <div className={appStyle.creditsContainer}>
            <div className={appStyle.creditsMain}>
              <span className={appStyle.creditsRemaining}>
                {remaining.toLocaleString()}
              </span>
              <span className={appStyle.creditsLabel}>
                Available User Slots
              </span>
            </div>

            <div className={appStyle.progressBar}>
              <div
                className={appStyle.progressFill}
                style={{ width: `${remainingPercentage}%` }}
              />
            </div>

            <div className={appStyle.capacityInfo}>
              <div className={appStyle.capacityRow}>
                <span>📋 Plan Limit:</span>
                <strong>{limit.toLocaleString()} users</strong>
              </div>
              {hasTopups && (
                <div className={appStyle.capacityRow}>
                  <span>➕ Top-ups Added:</span>
                  <strong className={appStyle.topupHighlight}>+{totalTopups.toLocaleString()} slots</strong>
                </div>
              )}
              <div className={appStyle.capacityRow}>
                <span>🎯 Total Capacity:</span>
                <strong>{totalCapacity.toLocaleString()} users</strong>
              </div>
            </div>

            <div className={appStyle.statsNote}>
              💡 <strong>How it works:</strong> This shows how many additional users you can add to your site. Each registered user consumes one slot. Top up to add more slots beyond your plan limit.
            </div>

            {isLow() && (
              <div className={appStyle.topUpSection}>
                <button onClick={handleTopUp} className={appStyle.topUpButton}>
                  👥 Top Up Site Users
                </button>
                <div className={appStyle.topUpInfo}>
                  Get 125 more user slots for ₹1500 (~₹12 per slot)
                </div>
              </div>
            )}

            {remainingPercentage < 10 && remaining > 0 && (
              <div className={appStyle.lowCreditsWarning}>
                ⚠️ Running low on user slots! Only {remaining.toLocaleString()} slots remaining ({Math.round(remainingPercentage)}% left). Top up now to add more users.
              </div>
            )}

            {remaining <= 0 && (
              <div className={appStyle.criticalWarning}>
                🚨 No user slots remaining! Please top up to add more users.
              </div>
            )}
          </div>
        )}
      </div>

      {showTopUpModal && (
        <div className={appStyle.modalOverlay} onClick={() => setShowTopUpModal(false)}>
          <div className={appStyle.modalContent} onClick={(e) => e.stopPropagation()}>
            <div className={appStyle.modalHeader}>
              <h3>👥 Top Up Site Users</h3>
              <button className={appStyle.modalClose} onClick={() => setShowTopUpModal(false)}>✕</button>
            </div>
            <div className={appStyle.modalBody}>
              <div className={appStyle.infoNote}>
                <strong>Current Capacity:</strong> {remaining.toLocaleString()} slots available<br />
                <strong>After Top-up:</strong> {remaining + topUpQuantity} slots available<br />
                <strong>Total Capacity:</strong> {totalCapacity + topUpQuantity} users (Plan: {limit} + Top-ups: {totalTopups + topUpQuantity})
              </div>
              <div className={appStyle.topUpOptions}>
                <div className={appStyle.topUpOption}>
                  <div className={appStyle.optionPrice}>₹1500</div>
                  <div className={appStyle.optionMessages}>+125 User Slots</div>
                  <div className={appStyle.optionPerMessage}>~₹12 per slot</div>
                  <button className={appStyle.optionButton} onClick={() => { setTopUpAmount(1500); setTopUpQuantity(125); }}>Select</button>
                </div>
                <div className={appStyle.topUpOption}>
                  <div className={appStyle.optionPrice}>₹3000</div>
                  <div className={appStyle.optionMessages}>+250 User Slots</div>
                  <div className={appStyle.optionPerMessage}>~₹12 per slot</div>
                  <button className={appStyle.optionButton} onClick={() => { setTopUpAmount(3000); setTopUpQuantity(250); }}>Select</button>
                </div>
                <div className={appStyle.topUpOption}>
                  <div className={appStyle.optionPrice}>₹4500</div>
                  <div className={appStyle.optionMessages}>+375 User Slots</div>
                  <div className={appStyle.optionPerMessage}>~₹12 per slot</div>
                  <button className={appStyle.optionButton} onClick={() => { setTopUpAmount(4500); setTopUpQuantity(375); }}>Select</button>
                </div>
              </div>
              <div className={appStyle.checkoutContainer}>
                <RazorpayCheckout cost={topUpAmount} planName={`Top Up - ${topUpQuantity} Site User Slots`} planCode="SITE_USERS_TOPUP" userLimit={null} appliedPromo={null} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}